<template>
    <div>
        <div class="date-block">
            <div class="date-title">
                <div>学习查询</div>
            </div>
            <el-date-picker
                    v-model="dateVal"
                    value-format="yyyy-MM-dd"
                    type="daterange"
                    align="center"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions">
            </el-date-picker>
            <div class="radio-block">
                <div>类型</div>
                <div>
                    <el-radio v-model="studyRadio" label="1">单词学习查询</el-radio>
                    <el-radio v-model="studyRadio" label="2">语法学习查询</el-radio>
                </div>
            </div>
        </div>
        <div class="search-btn">
            <el-button type="primary" @click="searchStudy">查询</el-button>
            <div style="width: 30px;"></div>
            <el-button type="danger" @click="resetSearch">重置</el-button>
        </div>

        <div class="info-list">
            <div class="item">
                <div style="font-size: 18px">学习内容</div>
                <div style="font-size: 18px">学习明细</div>
            </div>
            <div class="item">
                <div>
                    <img src="../../../assets/img/parents/pen.png" alt="">
                    <span>拼写时间</span>
                </div>
                <div>{{searchData.spell_time}}</div>
            </div>
            <div class="item">
                <div>
                    <img src="../../../assets/img/parents/clock.png" alt="">
                    <span>识别时间</span>
                </div>
                <div>{{searchData.learn_time}}</div>
            </div>
            <div class="item">
                <div>
                    <img src="../../../assets/img/parents/smiling.png" alt="">
                    <span>学习时长</span>
                </div>
                <div>{{searchData.study_time}}</div>
            </div>
            <div class="item">
                <div>
                    <img src="../../../assets/img/parents/statistics.png" alt="">
                    <span>学习总量</span>
                </div>
                <div>
                    <span v-if="searchData.word_num">{{searchData.word_num}}个</span>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import Lockr from 'lockr'
    import {searchStudy} from "@/api/teacher";

    export default {
        name: "LearningQuery",
        data() {
            return {
                pickerOptions: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                dateVal: '',//时间筛选
                studyRadio: '1',
                searchData: '',
            };
        },
        methods: {
            searchStudy() {
                console.log(this.dateVal, '查询时间');
                let params = {
                    token: Lockr.get('teacherToken'),
                    student_id: this.$route.query.student_id,
                    type: this.studyRadio,
                    start_time: this.dateVal[0],
                    end_time: this.dateVal[1],
                }
                if (!params.start_time) {
                    this.$message.error('请选择查询时间');
                    return
                }
                searchStudy(params).then(result => {
                    if (result.code === this.GLOBAL.Serve.SUCCESS_CODE) {
                        this.searchData = result.data.data
                    }
                })
            },
            //重置搜索条件
            resetSearch() {
                this.dateVal = ''
                this.searchData = ''
            },
        },
        created() {

        },
    }
</script>

<style scoped lang='less'>

    .date-block {
        width: 350px;
        margin: 0 auto;

        .date-title {
            display: flex;
            justify-content: center;
            padding: 20px 35px;
            font-size: 18px;
            font-weight: 600;
            color: #555;
        }
    }

    .radio-block {
        width: 350px;
        margin: 20px auto;

        > div:nth-of-type(1) {
            font-size: 18px;
            font-weight: 600;
            margin: 20px 0;
        }

        > div {
            text-align: center;
        }
    }

    .search-btn {
        display: flex;
        justify-content: center;
    }

    .info-list {
        color: #264287;
        margin-top: 30px;

        .item {
            display: flex;
            width: 620px;
            margin: 0 auto;
            border-bottom: 1px solid #E1E1E1;

            > div {
                width: 50%;
                padding: 20px 0;
                text-align: center;
                font-size: 16px;
                font-weight: 600;
            }

            > div:nth-of-type(1) {
                display: flex;
                align-items: center;
                justify-content: center;

                img {
                    width: 32px;
                    margin-right: 10px;
                }
            }

            > div:nth-of-type(2) {
                color: #416489;
            }
        }
    }
</style>